"use strict";
// (C) 2007-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverTimeComparisonTypes = void 0;
/**
 * @internal
 */
exports.OverTimeComparisonTypes = {
    SAME_PERIOD_PREVIOUS_YEAR: "same_period_previous_year",
    PREVIOUS_PERIOD: "previous_period",
    NOTHING: "nothing",
};
//# sourceMappingURL=OverTimeComparison.js.map